module.exports = __webpack_public_path__ + "img/industry3_m.d2b3f30e.jpg";